import React from "react";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import styles from "./Payment.module.sass";
import Item from "../Item";
import Icon from "../../../components/Icon";

const Confirmation = ({ className }) => {
  const navigate = useNavigate();

  const handleReturnToFormations = () => {
    // Rediriger vers la liste des formations
    navigate("/admin/folders");
  };

  return (
    <Item
      className={cn(styles.card, className)}
      title="Dossier créé avec succès !"
      classTitle="title-green"
    >
      <div className={styles.content}>
        <div className={styles.successMessage}>
          <Icon name="check-circle" size="48" />
          <h3>Félicitations !</h3>
          <p>Votre dossier a été créé et enregistré avec succès.</p>
        </div>
        
        <div className={styles.actions}>
          <button 
            className={cn("button-stroke", styles.secondaryButton)}
            onClick={handleReturnToFormations}
          >
            <Icon name="arrow-left" size="16" />
            Retourner aux dossiers
          </button>
        </div>
      </div>
    </Item>
  );
};

export default Confirmation;
